import React, { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import HomePage from "@/pages/HomePage";
import ReelSwiper from "@/pages/ReelSwiper";
import FavoritesPage from "@/pages/FavoritesPage";
import DailyQuotePage from "@/pages/DailyQuotePage";
import JourneyPage from "@/pages/JourneyPage";
import MilestonesPage from "@/pages/MilestonesPage";
import AudioLibraryPage from "@/pages/AudioLibraryPage";
import WhisperBackPage from "@/pages/WhisperBackPage";
import ProfilePage from "@/pages/ProfilePage";
import InnerVoicePage from "@/pages/InnerVoicePage";
import SignupPage from "@/pages/SignupPage";
import LoginPage from "@/pages/LoginPage";
import PersonalizationInsightsPage from "@/pages/PersonalizationInsightsPage";
import SafetyFeaturesPage from "@/pages/SafetyFeaturesPage";
import WaitlistPage from "@/pages/WaitlistPage";
import EmergencyCalmButton from "@/components/EmergencyCalmButton";
import EmergencyExit from "@/components/EmergencyExit";
import FloatingEmergencyExit from "@/components/FloatingEmergencyExit";
import { Toaster } from "@/components/ui/sonner";

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const isAuthenticated = localStorage.getItem('is_authenticated') === 'true';
  return isAuthenticated ? children : <Navigate to="/signup" />;
};

function App() {
  return (
    <div className="App">
      <EmergencyExit>
        <BrowserRouter>
          <Routes>
            {/* Public Routes */}
            <Route path="/signup" element={<SignupPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/waitlist" element={<WaitlistPage />} />
            
            {/* Protected Routes */}
            <Route path="/" element={<ProtectedRoute><HomePage /></ProtectedRoute>} />
            <Route path="/daily-quote" element={<ProtectedRoute><DailyQuotePage /></ProtectedRoute>} />
            <Route path="/journey" element={<ProtectedRoute><JourneyPage /></ProtectedRoute>} />
            <Route path="/milestones" element={<ProtectedRoute><MilestonesPage /></ProtectedRoute>} />
            <Route path="/audio" element={<ProtectedRoute><AudioLibraryPage /></ProtectedRoute>} />
            <Route path="/whisper-back" element={<ProtectedRoute><WhisperBackPage /></ProtectedRoute>} />
            <Route path="/profile" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
            <Route path="/insights" element={<ProtectedRoute><PersonalizationInsightsPage /></ProtectedRoute>} />
            <Route path="/inner-voice" element={<ProtectedRoute><InnerVoicePage /></ProtectedRoute>} />
            <Route path="/safety-features" element={<ProtectedRoute><SafetyFeaturesPage /></ProtectedRoute>} />
            <Route path="/reels" element={<ProtectedRoute><ReelSwiper /></ProtectedRoute>} />
            <Route path="/reels/:theme" element={<ProtectedRoute><ReelSwiper /></ProtectedRoute>} />
            <Route path="/favorites" element={<ProtectedRoute><FavoritesPage /></ProtectedRoute>} />
          </Routes>
          <EmergencyCalmButton />
          <FloatingEmergencyExit />
        </BrowserRouter>
        <Toaster position="top-center" />
      </EmergencyExit>
    </div>
  );
}

export default App;